<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Parâmetros</h1>
    <button class="btn btn-primary" (click)="novoParametro()">Incluir Novo Parâmetro</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Pesquisar por descrição ou categoria"
        [(ngModel)]="searchTerm"
        (keyup.enter)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
      <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()">Limpar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Descrição</th>
          <th scope="col">Categoria</th>
          <th scope="col">Valor Numérico</th>
          <th scope="col">Valor Mínimo</th>
          <th scope="col">Valor Máximo</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let parametro of pagedParametros">
          <td>{{ parametro.id }}</td>
          <td>{{ parametro.descricao }}</td>
          <td>{{ parametro.categoria }}</td>
          <td>{{ parametro.valorNumerico }}</td>
          <td>{{ parametro.valorMinimo }}</td>
          <td>{{ parametro.valorMaximo }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm" (click)="editarParametro(parametro.id)">Editar</button>
          </td>
        </tr>
        <tr *ngIf="pagedParametros.length === 0">
          <td colspan="7" class="text-center text-muted">Nenhum parâmetro encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
      </li>
    </ul>
  </nav>
</div>

